<template>
  <v-container fluid>
    <v-layout align-start>
      <v-flex>
        <v-card flat>
          <v-row no-gutters justify="center">
            <span style="font-size: 34px; color: #616161">
              <v-icon large class="pr-1 pb-2">add_shopping_cart</v-icon>
              Solicitudes de compra
            </span>
          </v-row>
          <v-card-text class="pa-0">
            <PurchaseRequestFilters class="pt-3" @refreshWarehouse="onFiltersChanged" :disable_all="disableFilters"
              :filter_default="defaultFilters" />
            <v-stepper flat v-model="page">
              <v-stepper-items>
                <v-stepper-content v-for="currentPage in steps" :key="`${currentPage}-content`" :step="currentPage"
                  class="pa-0">
                  <v-card flat v-show="page === 1">
                    <v-card outlined class="mt-2 pt-2">
                      <v-card-text class="pa-0">
                        <v-data-table :headers="tableHeaders" :items="requestList" locale="es-do"
                          :options.sync="options" :server-items-length="totalItems" :loading="loading"
                          loading-text="Cargando solicitudes..."
                          :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
                          no-data-text="No se encontraron solicitudes con los filtros aplicados">
                          <template v-slot:top>
                            <v-toolbar flat>
                              <v-row>
                                <v-col cols="2" align="center">
                                  <span :style="`font-size:15px`">
                                    Solicitudes: {{ totalItems }}
                                  </span>
                                </v-col>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-col cols="4" align="center">
                                  <v-text-field class="text-xs-center" v-model="search" append-icon="search"
                                    label="Buscar" single-line hide-details outlined dense>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="5" align="end">
                                  <v-row justify="end">
                                    <v-col cols="5" align="end">
                                      <v-autocomplete v-model="statusFilter" :items="itemStatus" color="cyanText"
                                        label="Estatus" outlined dense hide-details item-value="id" item-text="name">
                                      </v-autocomplete>
                                    </v-col>
                                    <v-col cols="2" align="end">
                                      <v-btn v-if="hasFeature('SHOP-045')" color="success" class="mr-2 pa-1" outlined @click="newRequest([])">
                                        <v-icon>add</v-icon> Nueva
                                      </v-btn>
                                    </v-col>
                                    <v-col cols="1" align="end">
                                      <v-btn color="success" icon :loading="loadingReport" @click="report()">
                                        <v-icon>mdi-download</v-icon>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-toolbar>
                          </template>
                          <template v-slot:[`item.status_description`]="{ item }">
                            <v-chip dark :color="statusConfig(1, item.status_id).color">
                              {{ item.status_description }}
                              <v-icon dark small class="pl-2">
                                {{
                                  statusConfig(2, item.status_id).icon
                                }}</v-icon>
                            </v-chip>
                          </template>
                          <template v-slot:[`item.ordered_percent`]="{ item }">
                            <div style="min-width: 110px">
                              <v-progress-linear :value="item.ordered_percent" height="16" rounded
                                :color="item.ordered_percent >= 100 ? 'green darken-1' : 'light-blue darken-1'">
                                <span class="white--text text-caption font-weight-bold">
                                  {{ item.ordered_percent }}%
                                </span>
                              </v-progress-linear>
                              <div v-if="item.rejected_percent > 0" class="text-caption red--text text--darken-2">
                                Rechazado: {{ item.rejected_percent }}%
                              </div>
                            </div>
                          </template>
                          <template v-slot:[`item.options`]="{ item }">
                            <v-menu>
                              <template v-slot:activator="{ attrs, on }">
                                <v-btn color="primary" plain text v-bind="attrs" v-on="on"
                                  class="pl-1 pr-0 font-weight-bold">Opciones
                                  <v-icon large dark> expand_more </v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item>
                                  <v-list-item-title>
                                    <v-btn text @click="viewDetail(item, false, 1)">
                                      <v-icon color="warning">read_more</v-icon>
                                      Ver solicitud
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="hasFeature('SHOP-045')">
                                  <v-list-item-title>
                                    <v-btn text @click="viewDetail(item, true, 2)">
                                      <v-icon color="light-blue darken-2">content_copy</v-icon>
                                      Copiar solicitud
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="item.status_id <= 2 && hasFeature('SHOP-045')">
                                  <v-list-item-title>
                                    <v-btn text @click="openConfirm(item, 3)">
                                      <v-icon color="error">sync_alt</v-icon>
                                      Cancelar solicitud
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="item.status_id === 1 && hasFeature('SHOP-045')">
                                  <v-list-item-title>
                                    <v-btn text @click="viewDetail(item, true, 1)">
                                      <v-icon color="orange lighten-2">edit</v-icon>
                                      Editar solicitud
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="item.status_id === 1 && hasFeature('SHOP-045')">
                                  <v-list-item-title>
                                    <v-btn text @click="openConfirm(item, 2)">
                                      <v-icon color="success">send</v-icon>
                                      Enviar solicitud
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="canClose(item) && hasFeature('SHOP-045')">
                                  <v-list-item-title>
                                    <v-btn text @click="openConfirm(item, 6)">
                                      <v-icon color="grey darken-1">mdi-lock</v-icon>
                                      Cerrar solicitud
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-card>
                  <v-card flat v-show="page === 2">
                    <RequestDetails v-if="page === 2" @exitDetail="detailClose" @save_request="save" :item="itemRequest"
                      :time_line_status="requestTimeLine" :item_list="articlesDetail" :can_edit="canEdit"
                      :location="detailLocation" :all_applicants="allApplicants" :warehouse="detailWarehouse"
                      :invalid_item_ids="activeInvalidItemIds" />
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <DialogConfirm :showDialog="dialogConfirm" :confirm_settings="confirmSettings" @closeDialog="sendOrCancel" />

    <v-dialog v-model="dialogInvalidItems" max-width="600" persistent>
      <v-card>
        <v-card-title class="headline">
          <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
          Artículos no disponibles en el catálogo destino
        </v-card-title>
        <v-card-text>
          <p>Los siguientes artículos no existen en el catálogo de la unidad de negocio/location seleccionada:</p>
          <v-simple-table dense>
            <thead>
              <tr>
                <th>ID</th>
                <th>Artículo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in invalidItems" :key="item.item_id">
                <td>{{ item.item_id }}</td>
                <td>{{ item.item_name }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogInvalidItems = false">
            Cancelar
          </v-btn>
          <v-btn color="warning" @click="removeInvalidItems">
            Remover y continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import PurchaseRequestFilters from "@/components/Shop/PurchaseRequestFilters.vue";
import RequestDetails from "@/components/Shop/RequestDetails.vue";
import DialogConfirm from "@/components/DialogConfirm.vue";
import ExcelJS from "exceljs";
import moment from "moment";

// Estatus calculados por requestListPaginated (no se guardan en el historial)
const REQUEST_STATUS_COMPLETED = 7;
const REQUEST_STATUS_REJECTED = 8;

// Estado de la lista que se refleja en la URL: ?status=&page=&per_page=&search=&request=
const queryInt = (value, fallback) => {
  const n = parseInt(value, 10);
  return Number.isInteger(n) && n > 0 ? n : fallback;
};

export default {
  data: (vm) => ({
    search: vm.$route.query.search || "",
    page: 1,
    steps: 2,
    dialogDetail: false,
    dialogReception: false,
    requestList: [],
    totalItems: 0,
    loading: false,
    loadingReport: false,
    options: {
      page: queryInt(vm.$route.query.page, 1),
      itemsPerPage: queryInt(vm.$route.query.per_page, 20),
      sortBy: [],
      sortDesc: [],
    },
    // true si el detalle se abrió con push en el historial (Volver = atrás del navegador)
    detailPushed: false,
    // La primera carga respeta la página de la URL en vez de volver a la 1
    firstLoad: true,
    fetchToken: 0,
    searchTimeout: null,
    requestTimeLine: [],
    articlesDetail: [],
    canEdit: false,
    headerTransfer: [
      {
        text: "ID",
        align: "start",
        value: "id",
      },
      { text: "Creacion", value: "requested_at" },
      { text: "Almacen", value: "warehouse_name" },
      { text: "Departamento", value: "department_name" },
      { text: "Proyecto", value: "project_name" },
      { text: "Solicitante", value: "requested_by" },
      { text: "% Ordenado", value: "ordered_percent" },
      { text: "Estatus", value: "status_description" },
      { text: "", value: "options", sortable: false },
    ],
    itemsFilters: {},
    itemRequest: { id: null },
    filters: {
      department_id: 0,
      location: { catalogue_id: "", id: "" },
      business: "",
      warehouse: { id: "", name: "" },
      dateStart: null,
      dateEnd: null,
    },
    itemStatus: [],
    statusFilter: queryInt(vm.$route.query.status, 0),
    refreshReceived: false,
    defaultFilters: [],
    confirmSettings: {
      btn_affirmative: "",
      btn_negative: "",
      icon: "",
      size: "",
      title: "",
    },
    dialogConfirm: false,
    tempRequest: { id: null, status_id: null },
    allApplicants: [],
    isCopying: false,
    dialogInvalidItems: false,
    invalidItems: [],
  }),
  components: {
    PurchaseRequestFilters,
    RequestDetails,
    DialogConfirm,
  },
  created() {
    this.getInitialData();
    const requestId = queryInt(this.$route.query.request, null);
    if (requestId) this.openRequestById(requestId);
  },
  computed: {
    disableFilters() {
      if (this.isCopying) return false;
      return this.page == 1 ? false : true;
    },
    tableHeaders() {
      if (!this.isAllLocations) return this.headerTransfer;
      const headers = [...this.headerTransfer];
      headers.splice(2, 0, { text: "Location", value: "location_name", sortable: false });
      return headers;
    },
    isAllLocations() {
      return this.getLocationId(this.filters.location) === 0;
    },
    isAllProjects() {
      return !this.filters.project?.id;
    },
    // Una solicitud existente usa siempre su propia location/almacén (puede abrirse por URL
    // o con location "Todos"); una nueva usa los filtros.
    detailLocation() {
      if (!this.itemRequest.id) return this.filters.location;
      return (
        this.$store.state.auth.locations.find(
          (l) => l.id == this.itemRequest.location_id
        ) || this.filters.location
      );
    },
    detailWarehouse() {
      if (!this.itemRequest.id) return this.filters.warehouse;
      return { id: this.itemRequest.warehouse_id, name: this.itemRequest.warehouse_name };
    },
    activeInvalidItemIds() {
      const currentIds = this.articlesDetail.map((a) => a.item_id);
      return this.invalidItems
        .filter((i) => currentIds.includes(i.item_id))
        .map((i) => i.item_id);
    },
  },
  watch: {
    "$route.query.request"(value) {
      const requestId = queryInt(value, null);
      if (!requestId) {
        if (this.page === 2 && this.itemRequest.id) {
          this.detailPushed = false;
          this.page = 1;
        }
        return;
      }
      if (requestId !== parseInt(this.itemRequest.id)) this.openRequestById(requestId);
    },
    options: {
      handler() {
        this.fetchRequests();
      },
      deep: true,
    },
    statusFilter() {
      this.goToFirstPage();
    },
    search() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.goToFirstPage(), 400);
    },
    'articlesDetail.length'() {
      if (this.invalidItems.length > 0) {
        this.invalidItems = this.invalidItems.filter((i) =>
          this.articlesDetail.some((a) => a.item_id === i.item_id)
        );
      }
    },
  },
  methods: {
    statusConfig(type, status_id) {
      if (status_id === REQUEST_STATUS_COMPLETED) {
        return { color: "green darken-3", icon: "mdi-check-all" };
      }
      if (status_id === REQUEST_STATUS_REJECTED) {
        return { color: "red darken-2", icon: "mdi-cancel" };
      }
      return this.time_line_config(type, status_id);
    },
    // Se puede cerrar mientras quede algo pendiente (Completada/Rechazada ya llegan con otro id)
    canClose(item) {
      return [2, 4, 5].includes(item.status_id);
    },
    getLocationId(location) {
   
      if (!location) {
        return null;
      }
      if (typeof location === "object") {
        const id = location.id ?? location.value ?? null;
       
        return id;
      }
 
      return location;
    },
    async getInitialData() {
      const request = await this.api_Get("shopping/request_status");
      this.itemStatus = await request.json();
      this.itemStatus.unshift({ id: 0, name: "Todo" });
      // Estatus calculados en el backend (no existen en ITEM_REQUEST_STATUS)
      this.itemStatus.push(
        { id: REQUEST_STATUS_COMPLETED, name: "Completada" },
        { id: REQUEST_STATUS_REJECTED, name: "Rechazada" }
      );
      const requestApplicants = await this.api_Get("shopping/applicants");
      const data = await requestApplicants.json();
      if (requestApplicants.status == 200) {
        this.allApplicants = data;
      }
    },
    getRequest(filters) {
      if (!filters || !filters.location) {
        console.warn("[PurchaseRequest] Skip getRequest: No filters or location");
        return;
      }
      this.filters = filters;
      this.syncUrl();
      if (this.firstLoad) {
        this.firstLoad = false;
        this.fetchRequests();
        return;
      }
      this.goToFirstPage();
    },
    // Volver a la página 1; el watcher de options dispara la consulta
    goToFirstPage() {
      if (this.options.page !== 1) {
        this.options = { ...this.options, page: 1 };
        return;
      }
      this.fetchRequests();
    },
    // Filtros que entiende el backend (requestListPaginated / request_details_reports)
    buildQueryFilters() {
      const locationId = this.getLocationId(this.filters.location);
      if (locationId == null || locationId === "undefined" || locationId === "") {
        return null;
      }
      // Location "Todos" = todas las locations de la unidad de negocio a las que el usuario tiene acceso
      const locationIds = this.isAllLocations
        ? this.$store.state.auth.locations
            .filter((l) => l.bus_id == this.filters.business)
            .map((l) => l.id)
        : [locationId];

      return {
        location_ids: locationIds,
        warehouse_id: this.isAllLocations ? null : this.filters.warehouse?.id || 0,
        department_id: this.filters.department_id || null,
        project_id: this.isAllProjects ? null : this.filters.project.id,
        date_start: this.filters.dateStart,
        date_end: this.filters.dateEnd,
        status_id: this.statusFilter || null,
        search: this.search || "",
        created_by: this.$store.state.auth.globalFeatures.includes("SHOP-042")
          ? null
          : this.$store.state.auth.user.user.user_id,
      };
    },
    async fetchRequests() {
      const filters = this.buildQueryFilters();
      if (!filters) return;

      // Sin almacén para la location seleccionada no hay solicitudes (igual que antes: WAREHOUSE_ID=0)
      if (!this.isAllLocations && !filters.warehouse_id) {
        this.requestList = [];
        this.totalItems = 0;
        return;
      }

      const token = ++this.fetchToken;
      this.loading = true;
      try {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        const request = await this.api_Post("shopping/requestListPaginated", {
          filters,
          page,
          items_per_page: itemsPerPage,
          sort_by: sortBy[0] || null,
          sort_desc: sortDesc[0] || false,
        });
        const data = await request.json();
        if (token !== this.fetchToken) return; // respuesta vieja
        if (request.status == 200) {
          data.data.forEach(this.mapRequestRow);
          this.requestList = data.data;
          this.totalItems = data.total;
          this.syncUrl();
        } else {
          this.$toast.error(data.error);
        }
      } catch (error) {
        if (token === this.fetchToken) {
          this.$toast.error("Error al consultar las solicitudes!. " + error);
        }
      } finally {
        if (token === this.fetchToken) this.loading = false;
      }
    },
    mapRequestRow(item) {
      const requested = parseFloat(item.qty_requested) || 0;
      const toPercent = (qty) =>
        requested > 0 ? Math.round((parseFloat(qty) / requested) * 100) : 0;
      item.ordered_percent = toPercent(item.qty_ordered);
      item.rejected_percent = toPercent(item.qty_rejected);
      item.requested_at = moment(item.requested_at).format("DD/MM/YYYY h:mm a");
      item.location_name =
        this.$store.state.auth.locations.find((l) => l.id == item.location_id)?.text || "";
      return item;
    },
    // Refleja en la URL el estado de la lista y la solicitud abierta
    syncUrl({ push = false } = {}) {
      const query = {};
      const f = this.filters;
      if (f.business) {
        const locationId = this.getLocationId(f.location);
        query.business = String(f.business);
        query.location = String(locationId);
        if (locationId !== 0 && f.warehouse?.id) query.warehouse = String(f.warehouse.id);
        if (f.department_id) query.department = String(f.department_id);
        if (f.project?.id) query.project = String(f.project.id);
        if (f.range) query.range = String(f.range);
        if (f.range == 5) {
          query.from = f.dateStart;
          query.to = f.dateEnd;
        }
      }
      if (this.statusFilter) query.status = String(this.statusFilter);
      if (this.options.page > 1) query.page = String(this.options.page);
      if (this.options.itemsPerPage !== 20) query.per_page = String(this.options.itemsPerPage);
      if (this.search) query.search = this.search;
      if (this.page === 2 && this.itemRequest.id) {
        query.request = String(parseInt(this.itemRequest.id));
      }
      const current = this.$route.query;
      const same =
        Object.keys(query).length === Object.keys(current).length &&
        Object.keys(query).every((k) => current[k] === query[k]);
      if (same) return;
      const navigate = push ? this.$router.push : this.$router.replace;
      navigate.call(this.$router, { query }).catch(() => {});
    },
    // Abre una solicitud por id (enlace ?request=), sin importar los filtros de la lista
    async openRequestById(requestId) {
      try {
        const request = await this.api_Post("shopping/requestListPaginated", {
          filters: {
            request_id: requestId,
            location_ids: this.$store.state.auth.locations.map((l) => l.id),
            created_by: this.$store.state.auth.globalFeatures.includes("SHOP-042")
              ? null
              : this.$store.state.auth.user.user.user_id,
          },
          page: 1,
          items_per_page: 1,
        });
        const data = await request.json();
        if (request.status !== 200 || data.data.length === 0) {
          this.$toast.warning("La solicitud #" + requestId + " no existe o no tiene acceso a ella");
          this.detailPushed = false;
          this.page = 1;
          this.syncUrl();
          return;
        }
        this.viewDetail(this.mapRequestRow(data.data[0]), false, 1, { fromUrl: true });
      } catch (error) {
        this.$toast.error("Error al consultar la solicitud!. " + error);
      }
    },
    onFiltersChanged(filters) {
      if (this.isCopying && this.page === 2) {
        this.filters = filters;
        this.validateCatalogueItems(filters);
        return;
      }
      this.getRequest(filters);
    },
    async validateCatalogueItems(filters) {
      if (!this.articlesDetail || this.articlesDetail.length === 0) return;

      const itemIds = this.articlesDetail.map((a) => a.item_id);
      const locationId = this.getLocationId(filters.location);

      if (!filters.business || !locationId) return; // location "Todos" (0) no aplica

      try {
        const request = await this.api_Post("inventory/validate_catalogue_items", {
          business_unit_id: filters.business,
          location_id: locationId,
          item_ids: itemIds,
        });
        const data = await request.json();

        if (request.status === 200 && !data.valid) {
          this.invalidItems = this.articlesDetail.filter((a) =>
            data.missing_item_ids.includes(a.item_id)
          );
          this.dialogInvalidItems = true;
        }
      } catch (error) {
        this.$toast.error("Error al validar artículos en el catálogo destino");
      }
    },
    removeInvalidItems() {
      const invalidIds = this.invalidItems.map((i) => i.item_id);
      this.articlesDetail = this.articlesDetail.filter(
        (a) => !invalidIds.includes(a.item_id)
      );
      this.invalidItems = [];
      this.dialogInvalidItems = false;
      if (this.articlesDetail.length === 0) {
        this.$toast.warning("No quedan artículos en la solicitud");
      }
    },
    async viewDetail(item_request, is_edit, type, { fromUrl = false } = {}) {
      item_request.note = item_request.comments.length > 0 ? item_request.comments[0].nota : '';
      const request = await this.api_Get(
        "shopping/request_detail/" + item_request.id
      );
      const data = await request.json();
      if (request.status == 200) {
        let articles = [];
        for (let item of data) {
          let image = "image-not-aviable.jpg";
          if (

            item.image_json != null
          ) {
            image = this.get_storage(item.image_json)

          }
          articles.push({
            item_id: item.item_id,
            item_name: item.item_name,
            requested_quantity: parseFloat(item.quantity).toFixed(2),
            image_url: item.item_image_url,
            item_image: image,
            unit: item.unit_name,
            unit_name: item.unit_name,
            // Al copiar, la nueva solicitud no hereda las órdenes
            orders: type == 2 ? [] : item.orders || [],
          });
        }
        if (type == 2) {
          //copiar y crear nueva
          this.refreshReceived = false;
          this.isCopying = true;
          this.newRequest(articles);
          return;
        }
        this.articlesDetail = articles;
        this.canEdit = is_edit;
        this.requestTimeLine = item_request.request_history;
        this.itemRequest = item_request;
        this.page = 2;
        // Desde la lista: push, para que el atrás del navegador vuelva a la lista
        if (!fromUrl) this.detailPushed = true;
        this.syncUrl({ push: !fromUrl });
      } else {
        this.$toast.error("Error al consultar el detalle!." + data.error);
      }
    },
    newRequest(items) {
      // if (
      //   this.filters.warehouse == undefined ||
      //   this.filters.warehouse.id == null
      // ) {
      //   this.$toast.warning("Escoja un almacen!");
      //   return;
      // }
      if (this.isAllLocations) {
        this.$toast.warning("Escoja una location para crear la solicitud!");
        return;
      }
      if (this.isAllProjects) {
        this.$toast.warning("Escoja un proyecto para crear la solicitud!");
        return;
      }
      if (this.filters.department_id == null) {
        this.$toast.warning("Escoja un departamento!");
        return;
      }
      this.articlesDetail = items;
      this.canEdit = true;
      this.itemRequest = { id: null, status_id: 1 };
      this.requestTimeLine = [{ name: "Borrador", status_id: 1 }];
      this.page = 2;
    },
    async save(type) {
      let data;
      try {
        // Una solicitud existente conserva sus datos (puede estar abierta por URL o con
        // filtros "Todos"); una nueva toma los de los filtros.
        const existing = this.itemRequest.id ? this.itemRequest : null;
        const request = await this.api_Post("shopping/save_request", {
          request_id: type.request_id,
          business_unit_id: existing ? existing.business_unit_id : this.filters.business,
          location_id: existing
            ? existing.location_id
            : this.getLocationId(this.filters.location),
          department_id: existing ? existing.department_id : this.filters.department_id,
          warehouse_id: existing ? existing.warehouse_id : this.filters.warehouse.id,
          project_id: existing ? existing.project_id : this.filters.project.id,
          user_id: this.$store.state.auth.user.user.user_id,
          request_by: type.applicant,
          status_id: type.saveType,
          items: this.articlesDetail.map((item) => {
            const copy = { ...item };
            delete copy.orders; // solo informativo, no se guarda
            return copy;
          }),
          note: type.note,
        });
        data = await request.json();
        if (request.status == 200) {
          this.$toast.success("Guardado correctamente!");
          this.detailClose();
          this.fetchRequests();
        } else {
          this.$toast.error("Error al registrar la solicutud!." + data.error);
        }
      } catch (error) {
      } finally {
        type.done?.();
      }
    },
    detailClose() {
      this.isCopying = false;
      if (this.detailPushed) {
        // Volver por el historial: el watcher de $route.query.request cierra el detalle
        this.detailPushed = false;
        this.$router.back();
        return;
      }
      this.page = 1;
      this.syncUrl();
    },
    openConfirm(itemRequest, type) {
      if (type == 6) {
        this.confirmSettings.title = "Seguro que desea cerrar esta solicitud? Al cerrarla, ya no sera visible para el comprador.";
        this.confirmSettings.icon = "mdi-lock";
        this.confirmSettings.btn_affirmative = "Si, cerrar solicitud";
      } else if (type == 2) {
        this.confirmSettings.title = "Seguro que desea enviar esta solicitud?";
        this.confirmSettings.icon = "send";
        this.confirmSettings.btn_affirmative = "Si, enviar!";
      } else {
        this.confirmSettings.title = "Seguro que desea cancelar esta solicitud?";
        this.confirmSettings.icon = "cancel";
        this.confirmSettings.btn_affirmative = "Si, cancelar solicitud";
      }
      this.confirmSettings.btn_negative = "No, volver";
      this.confirmSettings.size = "45%";
      this.tempRequest = { id: itemRequest.id, status_id: type };
      this.dialogConfirm = true;
    },
    async sendOrCancel(confirm) {
      if (confirm == false) {
        this.dialogConfirm = false;
        return;
      }
      let data = null;
      try {
        const request = await this.api_Post("shopping/send_cancel_request", {
          request_id: this.tempRequest.id,
          status_id: this.tempRequest.status_id,
          user_id: this.$store.state.auth.user.user.user_id,
        });
        data = await request.json();
        if (request.status == 200) {
          const msg = this.tempRequest.status_id == 6
            ? "Solicitud cerrada correctamente!"
            : this.tempRequest.status_id == 2
              ? "Solicitud enviada correctamente!"
              : "Solicitud cancelada correctamente!";
          this.$toast.success(msg);
          this.dialogConfirm = false;
          this.fetchRequests();
        } else {
          this.$toast.error("Error al registrar la solicutud!." + data.error);
        }
      } catch (error) {
        this.$toast.error(data.error);
      }
    },
    async report() {
      const filters = this.buildQueryFilters();
      if (!filters || this.totalItems === 0) {
        this.$toast.warning("No hay solicitudes para generar el reporte!");
        return;
      }
      this.loadingReport = true;
      try {
        // El backend aplica los mismos filtros: incluye todas las páginas
        const request = await this.api_Post("shopping/request_details_reports", {
          filters,
        });
        const data = await request.json();
        if (request.status == 200) {

          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet("Orden de Compra");
          // Definir encabezados
          worksheet.columns = [
            { header: "ID Solicitud", key: "request_id", width: 10 },
            { header: "ID Orden", key: "order_id", width: 10 },
            { header: "Suplidor", key: "supplier", width: 10 },
            { header: "Item ID", key: "item_id", width: 10 },
            { header: "Item", key: "item_name", width: 10 },
            { header: "Unidad de medida", key: "unit", width: 10 },
            { header: "Cantidad", key: "quantity", width: 10 },
            { header: "Estatus de solicitud", key: "status", width: 10 },
            { header: "Estatus de orden", key: "last_order_status", width: 10 },
          ];

          data.forEach((item) => {
            worksheet.addRow({
              request_id: item.item_request_id,
              order_id: item.order_id,
              supplier: item.supplier,
              item_id: item.item_id,
              item_name: item.item_name,
              unit: item.unit,
              quantity: parseFloat(item.quantity).toFixed(2),
              status: item.status,
              last_order_status: item.last_order_status
            });
          });

          // Generar el archivo Excel
          const buffer = await workbook.xlsx.writeBuffer();
          const blob = new Blob([buffer], { type: "application/octet-stream" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Reporte de solicitudes.xlsx`;
          link.click();
        } else {
          this.$toast.error("Error al generar el reporte!." + data.error);
        }
      } catch (error) {
        this.$toast.error("Error al generar el reporte!." + error);
      } finally {
        this.loadingReport = false;
      }
    }
  },
};
</script>
